import { api, apiFile } from "api/api";
import { AxiosError } from "axios";
import CentroCusto from "model/administracao/cadastro/centrocusto/CentroCusto";
import Usuario from "model/administracao/cadastro/Usuario";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import ViagemDespesa from "model/viagem/ViagemDespesa";
import ViagemTipoDespesa from "model/viagem/ViagemTipoDespesa";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";

class ViagemDespesaService implements BaseServiceCadastros<ViagemDespesa> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/viagemDespesa/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    salvar(data: FormData) {
        return new Promise<ViagemDespesa>((resolve, reject): void => {
            apiFile
                .post(`/viagemDespesa`, data)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<ViagemDespesa>((resolve, reject): void => {
            api
                .get(`/viagemDespesa/consultar/${id}`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(viagemDespesa: ViagemDespesa) {
        return new Promise<ViagemDespesa>((resolve, reject): void => {
            api
                .post(`/viagemDespesa/incluir`, JSON.stringify(viagemDespesa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(viagemDespesa: ViagemDespesa) {
        return new Promise<ViagemDespesa>((resolve, reject): void => {
            api
                .put(`/viagemDespesa/editar`, JSON.stringify(viagemDespesa))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/viagemDespesa/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getUsuariosDisponiveis() {
        return new Promise<Usuario[]>((resolve, reject): void => {
            api
                .get(`/viagemDespesa/usuariosDisponiveis`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getCentroCustoDisponiveis() {
        return new Promise<CentroCusto[]>((resolve, reject): void => {
            api
                .get(`/viagemDespesa/centroscusto`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getTiposDespesa() {
        return new Promise<ViagemTipoDespesa[]>((resolve, reject): void => {
            api
                .get(`/viagemDespesa/tiposDespesa`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getRelatorioListagem(filter?: DataTableFilterMeta | null) {
        return new Promise<string>((resolve, reject): void => {
            let url = `/viagemDespesa/report/listagem`;
            if (filter) {
                url += getFilters(filter)
            }
            api
                .get(url, { responseType: 'arraybuffer' })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getSituacao(situacao: string) {
        if (situacao === 'ENVIADA_APROVACAO') {
            return 'Aprovação pendente'
        }
        if (situacao === 'APROVADA') {
            return 'Aprovada'
        }
        if (situacao === 'REJEITADA') {
            return 'Rejeitada'
        }
    }

    getStatusFilter(): any[] {
        return [
            { label: 'Aprovação pendente', value: '1' },
            { label: 'Aprovada', value: '2' },
            { label: 'Rejeitada', value: '3' },
        ]
    }

    getSituacaoAprovacao(situacao: string) {
        if (situacao === 'ABERTA') {
            return 'Aberta'
        }
        if (situacao === 'APROVADA') {
            return 'Aprovada'
        }
        if (situacao === 'REJEITADA') {
            return 'Rejeitada'
        }
        if (situacao === 'NAO_RESPONDIDA') {
            return 'Não respondida'
        }
        return "";
    }
}

export default ViagemDespesaService;